// 本地 UI 预览只允许在开发环境开启，防止生产构建误用绕过逻辑
export const isLocalUiPreview = process.env.NODE_ENV === 'development' &&
  process.env.VUE_APP_LOCAL_UI_PREVIEW === 'true'

export function createLocalPreviewSession() {
  localStorage.setItem('token', 'local-ui-preview-token')
  localStorage.setItem('user', JSON.stringify({
    userId: 'local-preview-user',
    name: '本地预览用户',
    tel: ''
  }))
  localStorage.setItem('hc_staff_privilege', '*')
  localStorage.setItem('local-ui-preview', 'true')
}

export function isLocalPreviewSession() {
  return isLocalUiPreview && localStorage.getItem('local-ui-preview') === 'true'
}
